import cursor from "@/scripts/components/cursor";

const paginationContainer = document.querySelectorAll('[data-pagination-container]');

export default {
  init: () => {
    paginationContainer.forEach((el) => {
      const visibleCountAttr = parseInt(el.getAttribute('data-pagination-visible'), 10) || 10;
      const incrementAttr = parseInt(el.getAttribute('data-pagination-per-view'), 10) || 5;
      const list = el.querySelector('[data-pagination-list]');
      const items = list.children;
      const loadMoreBtn = el.querySelector('[data-pagination-load-more]');
      const hideBtn = el.querySelector('[data-pagination-hide]');
      let visibleCount = visibleCountAttr;
      let loadMoreClicked = false;

      loadMoreBtn.addEventListener('click', () => {
        visibleCount += incrementAttr;
        loadMoreClicked = true;
        updateVisibility();
        cursor.reinitializeCursors();
      });

      hideBtn.addEventListener('click', () => {
        visibleCount = visibleCountAttr;
        loadMoreClicked = false;
        updateVisibility();
        cursor.reinitializeCursors();
      });

      updateVisibility();
      cursor.reinitializeCursors();

      function updateVisibility() {
        for (let i = 0; i < items.length; i++) {
          items[i].style.display = i < visibleCount ? 'list-item' : 'none';
        }

        const shouldShowLoadMore = items.length > visibleCount;
        const shouldShowHide = loadMoreClicked && items.length > visibleCountAttr;

        loadMoreBtn.style.display = shouldShowLoadMore ? 'inline-block' : 'none';
        hideBtn.style.display = shouldShowHide ? 'inline-block' : 'none';
      }
    });
  }
}
